import { Injectable } from '@angular/core';
import { AgenciaService } from '../services/agencia-service.service';
import { Observable, of } from 'rxjs';
import { take, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResolveAgenciaService {

  constructor(private agenciaService: AgenciaService) { }


  resolve(): Observable<any> {
    return this.agenciaService.findAll().pipe(
      take(1),
      mergeMap(teste => {
        return of(teste['object']);
      })
    );
  }
}
